import { useContext } from 'react';

import { SubscriptionContext } from 'context';
import { SubscriptionContextValues } from 'types';

export function useSubscription(): SubscriptionContextValues {
  return useContext(SubscriptionContext);
}
